import React from 'react';

import _ from 'lodash';

import InputSelectField from './InputSelectField';
import FeeTable from './FeeTable';

import Fee from '../../Entities/Fee';


import './AccessDeviceTableRow.scss';


class AccessDeviceTableRow extends React.Component {
  _onFeeChange = (ident, value) => {
    this._onInputChange('fee')(value);
  }


  _onInputChange(inputId) {
    return value => {
      const { onValueChange } = this.props;

      switch (inputId) {
        case 'offered':
        case 'required':
        case 'charge':
          if (value !== null) value = (value === 'true' || value === true) ? true : false;
          break;
        default:
      }

      const accessDevice = _.cloneDeep(this.props.accessDevice);

      if (inputId === 'charge') {
        accessDevice.data[inputId].value = value;

        accessDevice.fields.fee.value = (value) ?
          new Fee('ACCESS_DEVICE') :
          null;
      }
      else {
        accessDevice.fields[inputId].value = value;
      }

      onValueChange(accessDevice);
    };
  }


  handleRemoveAccessDeviceClick = () => {
    this.props.onValueChange(null);
  }


  render() {
    const {
      accessDevice,
      ident,
      inputId,
      editMode,
      fieldConfiguration,
      activeAccessDeviceTypes
    } = this.props;

    const disabledMode = {
      ...{
        type: false,
        offered: false,
        required: false,
        charge: false,
        fee: {
          start_date: false,
          price: false,
          tax_1: false,
          tax_2: false,
          tax_3: false,
          tax_4: false
        }
      },
      ...this.props.disabledMode || {}
    };

    const displayFeeTable = accessDevice.fields.fee.value !== null;
    const feeTableRows = [];
    if (displayFeeTable) {
      feeTableRows.push({ ident: 0, data: accessDevice.fields.fee.value });
    }

    const typeInputOptions = [{ value: null, label: '' }];
    for (let type of fieldConfiguration.type.options) {
      const option = {
        ...type,
        disabled: (type.value !== accessDevice.fields.type.value &&
          activeAccessDeviceTypes.includes(type.value)
        )
      };
      typeInputOptions.push(option);
    }

    return (
      <div className="parkchirp--access-device-table-row">
        <div className="parkchirp--access-device-table-row--access-device-container">
          <div className={`parkchirp--access-device-table--cell` +
            ` parkchirp--access-device-table--device-type-column`}>
            <InputSelectField inputId={`${inputId}--${ident}--type`}
              options={typeInputOptions}
              value={accessDevice.fields.type.value}
              onChange={this._onInputChange('type')}
              editMode={editMode}
              disabledMode={disabledMode.type}
            />
          </div>
          <div className={`parkchirp--access-device-table--cell` +
            ` parkchirp--access-device-table--device-offered-column`}>
            <InputSelectField inputId={`${inputId}--${ident}--offered`}
              options={[{ value: null, label: '' }, ...fieldConfiguration.offered.options]}
              value={accessDevice.fields.offered.value}
              onChange={this._onInputChange('offered')}
              editMode={editMode}
              disabledMode={disabledMode.offered}
            />
          </div>
          <div className={`parkchirp--access-device-table--cell` +
            ` parkchirp--access-device-table--device-required-column`}>
            <InputSelectField inputId={`${inputId}--${ident}--required`}
              options={[{ value: null, label: '' }, ...fieldConfiguration.required.options]}
              value={accessDevice.fields.required.value}
              onChange={this._onInputChange('required')}
              editMode={editMode}
              disabledMode={disabledMode.required}
            />
          </div>
          <div className={`parkchirp--access-device-table--cell` +
            ` parkchirp--access-device-table--device-charge-column`}>
            <InputSelectField inputId={`${inputId}--${ident}--charge`}
              options={[{ value: null, label: '' }, { value: true, label: 'Yes' }, { value: false, label: 'No' }]}
              value={accessDevice.data.charge.value}
              onChange={this._onInputChange('charge')}
              editMode={editMode}
              disabledMode={disabledMode.charge}
            />
          </div>
          <div className={`parkchirp--access-device-table--cell` +
            ` parkchirp--access-device-table--actions-column`}>
            {(editMode) &&
              <button type="button"
                className="parkchirp--button-as-link"
                onClick={this.handleRemoveAccessDeviceClick}>
                Remove
              </button>
            }
          </div>
        </div>
        {(displayFeeTable) &&
          <div className="parkchirp--access-device-table-row--fee-container">
            <div className="parkchirp--access-device-table--cell">
              <FeeTable inputId={`${inputId}--${ident}--fee`}
                feeRows={feeTableRows}
                onFeeChange={this._onFeeChange}
                editMode={editMode}
                disabledMode={disabledMode.fee}
              />
            </div>
          </div>
        }
      </div>
    );
  }
}
export default AccessDeviceTableRow;
